import styled from 'styled-components';
import Input from '../../components/Inputs/Input';
import theme from '../../styles/defaultTheme';

export const Card = styled.div`
    display: flex;
    align-items: flex-end;
    margin-left: -25px;
    margin-bottom: 20px;

    & button {
        margin-bottom: 10px;
        height: 48px;
    }
`;

export const ButtomCard = styled.button`
    width: 100%;
    
    min-height: 108px;
    text-align: left;
    background-color: ${(props) => props.theme.white};
    border: none;
    border-radius: 8px;
    padding-top: 25px;
    padding-bottom: 25px;
    margin-bottom: 10px;
    cursor: pointer;
    outline: none;

    & .iconEdit {
        position: relative;
        top: -37px;
        margin-right: 10px;
    }
`;

export const CardNoCursorPointer = styled.div`
    width: 100%;
    
    min-height: 108px;
    text-align: left;
    background-color: ${(props) => props.theme.white};
    border: solid 1px ${(props) => props.theme.borderWhite};
    border-radius: 16px;
    padding-top: 25px;
    padding-bottom: 25px;
    margin-bottom: 10px;
    cursor: default;
    outline: none;

    & .iconEdit {
        position: relative;
        top: -37px;
        margin-right: 10px;
    }
`;

export const Title = styled.div`
    font-size: ${theme.font.size18};
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
    color: ${(props) => props.theme.orange};
    margin-right: 10px;
`;

export const SubTitle = styled.div`
    font-size: ${theme.font.size14};
    color: ${(props) => props.theme.grey};
    font-weight: bold;
    text-align: left;
    margin-right: 10px;
`;

export const Desc = styled.div`
    font-size: ${theme.font.size14};
    color: ${(props) => props.theme.grey};
    text-align: left;
    margin-right: 10px;
`;

export const SpacingCard = styled.div``;

export const CustomInput = styled(Input)`
    background-color: ${(props) => props.theme.disabledGrey10} !important;
    color: ${(props) => props.theme.grey} !important;
    border: 1px solid ${(props) => props.theme.lightGrey40}
`;